export const isEmptyObject = (obj: object): boolean => {
    return obj === null || obj === undefined || Object.keys(obj).length === 0;
};

export const extractNumberFromString = (value: string): number => {
    const result = Number(value.replace(/[^0-9.-]/g, ''));

    return isNaN(result) ? 0 : result;
};

export const isNullishOrEmptyString = (value: any): boolean => {
    if (typeof value !== 'string' || !value.trim()) return true;
    return false;
};
